import React, { useEffect, useRef, useState } from "react";
import { Switch, FormControlLabel, Button } from "@deere/isg.component-library";
import useApiCall from "../hooks/useApiCall";
import "./EngineeringTools.css"; // Import the CSS file
import { IconCircleClose } from "@deere/icons";
import JsonTreeViewer from "./JsonTreeViewer";
import MQTTOrgExplorer from "./MQTTOrgExplorer";
import TestMongoDB from "./tools/TestMongoDB";
import EndToEndTest from "./tools/EndToEndTest";
import PipelineTimingTest from "./tools/PipelineTimingTest";
import { useMap } from "@vis.gl/react-google-maps";
// import { addCustomLayer } from './tools/tileOverlay';

// const backendURI = '18.219.96.136/API';
const backendURI = process.env.REACT_APP_STRIPPED_BACKEND_URI;

interface EngineeringToolsProps {
  onClose: () => void;
  fullMQTT: any;
  setOrgName: (newOrgName: string) => void;
  orgName: string;
  devToolsOrgOverride: boolean;
  onRevertToHeaderOrg: () => void;
  headerOrgName: string;
  cabControlFullscreen: boolean;
  setCabControlFullscreen: (value: boolean) => void;
}

// This is temporary
let mqttObject = {
  "Dune/Gilroy/Haul/ADT/260/1/BinRaisePercent": {
    percent: 0,
  },
  "Dune/Gilroy/Haul/ADT/260/1/front_axle_center/GlobalPose": {
    location: {
      longitude: -121.52212407699948,
      latitude: 36.952656895,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune/Gilroy/Haul/ADT/260/1/WorkState": {},
  "Dune/Gilroy/Haul/ADT/260/1/articulation_joint/GlobalPose": {
    location: {
      longitude: -121.52214384757241,
      latitude: 36.952656895,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune/Gilroy/Haul/ADT/260/1/rear_axle_center/GlobalPose": {
    location: {
      longitude: -121.52218702899896,
      latitude: 36.952656895,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune/Gilroy/Haul/ADT/260/1/bin_rear/GlobalPose": {
    location: {
      longitude: -121.52218927404195,
      latitude: 36.952656895,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune/Gilroy/Haul/ADT/260/1/MachineState/Pose": {
    position: {
      x: 0,
      y: 0,
      z: 0,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
    speed: 0,
  },
  "Dune/Gilroy/Haul/ADT/260/1/MachineState/GlobalPose": {
    location: {
      longitude: -121.52213646770291,
      latitude: 36.95265843094354,
      altitude: 0,
      heading: 90,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
    speed: 0,
    active: false,
  },
  "orchestrator/broker/tests/orchestratorBackendTestMessageId/849281230428312/Position": {
    x: 123.1,
    y: 456.2,
    z: 789.3,
  },
  "Dune_Sim5/JobSite/56/ADT/310/5/BinRaisePercent": {
    percent: 0,
  },
  "Dune_Sim5/JobSite/56/ADT/310/5/WorkState": {},
  "Dune_Sim5/JobSite/56/ADT/310/5/front_axle_center/GlobalPose": {
    location: {
      longitude: -90.71884669646289,
      latitude: 42.584827,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune_Sim5/JobSite/56/ADT/310/5/articulation_joint/GlobalPose": {
    location: {
      longitude: -90.71886814720119,
      latitude: 42.584827,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune_Sim5/JobSite/56/ADT/310/5/rear_axle_center/GlobalPose": {
    location: {
      longitude: -90.71891499999866,
      latitude: 42.584827,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune_Sim5/JobSite/56/ADT/310/5/bin_rear/GlobalPose": {
    location: {
      longitude: -90.71891743590797,
      latitude: 42.584827,
      altitude: -0.4617,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
  },
  "Dune_Sim5/JobSite/56/ADT/310/5/MachineState/GlobalPose": {
    location: {
      longitude: -90.71886013999365,
      latitude: 42.58482853450566,
      altitude: 0,
      heading: 90,
    },
    orientation: {
      roll: 0,
      pitch: 0,
      yaw: 0,
    },
    speed: 0,
    active: false,
  },
};

const FullMqttDisplay = (fullMQTT: any) => {
  function getContext(obj: any, indent = 0) {
    // Check if the input is an object or an array
    if (obj === null) {
      return "null"; // Handle null explicitly
    }

    if (typeof obj !== "object") {
      return String(obj); // Convert non-object types to string
    }

    // Initialize the result string with appropriate indentation
    let result = "";
    const padding = " ".repeat(indent); // Create indentation spaces

    if (Array.isArray(obj)) {
      result += "[\n"; // Start array representation
      for (let i = 0; i < obj.length; i++) {
        result += `${padding}  ${getContext(obj[i], indent + 2)}`; // Recursive call for each element
        if (i < obj.length - 1) {
          result += ",\n"; // Add comma if not last element
        }
      }
      result += `\n${padding}]`; // Close array representation
    } else {
      result += "{\n"; // Start object representation
      const keys = Object.keys(obj);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        result += `${padding}  ${String(key)}: ${getContext(obj[key], indent + 2)}`; // Recursive call for each property
        if (i < keys.length - 1) {
          result += ",\n"; // Add comma if not last property
        }
      }
      result += `\n${padding}}`; // Close object representation
    }

    return result; // Return the final string representation
  }

  const [fullMQTTText, setFullMQTTText] = useState("");
  useEffect(() => {
    setFullMQTTText(getContext(fullMQTT));
    console.log();
  }, [fullMQTT]);

  return <div>{fullMQTTText}</div>;
};

const ChatComponent = () => {
  const [input, setInput] = useState("");
  const [response, setResponse] = useState("");
  const [isStreaming, setIsStreaming] = useState(false);

  const handleSend = async () => {
    if (!input.trim() || isStreaming) return;
    setResponse(""); // Clear previous response
    setIsStreaming(true);
    try {
      const res = await fetch(`/API/AI/stream`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ messages: [input] }),
      });

      if (!res.ok) {
        setResponse("Error: " + res.statusText);
        return;
      }

      if (!res.body) {
        return;
      }

      const reader = res.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let done = false;

      while (!done) {
        const { done: readerDone, value } = await reader?.read();
        done = readerDone;
        if (value) {
          setResponse((prev) => prev + decoder.decode(value)); // Append new parts to response
        }
      }
    } catch (error) {
      setResponse("Error: Failed to connect to AI service");
    } finally {
      setIsStreaming(false);
    }
  };

  return (
    <div>
      <h1>Chat with AI</h1>
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Type your message"
        disabled={isStreaming}
      />
      <button onClick={handleSend} disabled={!input.trim() || isStreaming}>Send</button>
      <div>
        <h2>Response:</h2>
        <pre>{response}</pre> {/* Display the streamed response */}
      </div>
    </div>
  );
};

let breakMQTTLoop = false;

const EngineeringTools: React.FC<EngineeringToolsProps> = ({
  onClose,
  fullMQTT,
  setOrgName,
  orgName,
  devToolsOrgOverride,
  onRevertToHeaderOrg,
  headerOrgName,
  cabControlFullscreen,
  setCabControlFullscreen,
}) => {
  const mapRef = useMap("mainMap");
  const [fileNames, setFileNames] = useState<string[]>([]);
  const [divString, setDivString] = useState<string>("Text Here");
  const map = useMap("mainMap");

  const [topic, setTopic] = useState<string>(""); // State for MQTT topic
  const [message, setMessage] = useState<string>(""); // State for MQTT message
  const [isSendingMQTT, setIsSendingMQTT] = useState(false);
  const [mqttFeedback, setMqttFeedback] = useState<{ type: "success" | "error"; msg: string } | null>(null);

  function handleLogOut() {
    //setUserVerified(false);
  }

  const [mqttData, setMqttData] = useState({});
  async function MqttHandler() {
    // const [mqttObject, setmqttObject] = useState({ "empty JSON": "I am empty" });

    async function getMQTTData() {
      // const requestURL = "http://localhost/API/MQTT";
      const requestURL = "/API/MQTT";

      return await fetch(requestURL, {
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        credentials: "same-origin", // Adding for CORS
      }).then(async (response) => {
        // console.log(response);
        if (response !== null) {
          let responseJSON = await response.json();
          if (responseJSON !== null) {
            // console.log(responseJSON);
            // console.log("This is a good JSON");
            // console.log(responseJSON);
            return responseJSON;
          } else {
            console.error("Error: there was no valid response JSON");
            return { "empty fetch JSON": "I am empty" };
          }
        } else {
          return { "empty fetch JSON": "I am empty" };
        }
      });
    }

    // Function to trim the mqttObject
    function trimObject(objectToTrim: any) {
      for (const key in objectToTrim) {
        if (key == "orchestrator" || key == "mqtt_cpp_topic1") {
          delete objectToTrim[key];
        }
        for (const key2 in objectToTrim[key]) {
          // console.log(key2);
          const child = objectToTrim[key];
          if (key2 == "__v" || key2 == "_id" || key2 == "name") {
            delete objectToTrim[key][key2];
          }
        }
      }
      return objectToTrim;
    }

    async function fetchDataCallback() {
      // console.log("fetching MQTT data");

      let myNewJSON = await getMQTTData();
      mqttObject = trimObject(myNewJSON);
      // console.log("mqttObject", mqttObject);
      setMqttData(mqttObject);
      // console.log(mqttObject);
      if (orgName in mqttObject) {
        // setOrgData(mqttObject[orgName]);
      } else {
        // console.log("The proper user org was not found!");
        // setOrgData(Object.values(mqttObject)[0]);
      }

      // waiting then fetching again
      await new Promise((r) => setTimeout(r, 0.5 * 1000));
      if (!breakMQTTLoop) {
        fetchDataCallback();
      } else {
        breakMQTTLoop = false;
      }
    }
    if (!breakMQTTLoop) fetchDataCallback();

    // return <> <button onClick={fetchDataCallback}>Start fetch loop</button></>
  }

  const [fetchEnabled, setFetchEnabled] = useState(false);

  useEffect(() => {
    if (fetchEnabled) {
      breakMQTTLoop = false;
      MqttHandler();
    } else {
      breakMQTTLoop = true;
    }

    return () => {
      breakMQTTLoop = true;
    };
  }, [fetchEnabled]);

  // Function to change the map tiles and type
  function changeMapTileType() {
    if (mapRef) {
      const customTileLayer = new google.maps.ImageMapType({
        getTileUrl: (coord, zoom) => {
          // https://your-custom-tile-server/{z}/{x}/{y}.png
          // https://mw1.google.com/mw-planetary/lunar/lunarmaps_v1/clem_bw/{z}/{x}/{y}.jpg
          return `https://mw1.google.com/mw-planetary/lunar/lunarmaps_v1/clem_bw/{z}/{x}/{y}.jpg`
            .replace("{z}", zoom.toString())
            .replace("{x}", coord.x.toString())
            .replace("{y}", coord.y.toString());
        },
        tileSize: new google.maps.Size(256, 256), // Adjust based on your tile size
        name: "Custom Tile Layer",
        maxZoom: 18,
        minZoom: 0,
      });

      mapRef.mapTypes.set("custom_tiles", customTileLayer);
      mapRef.setMapTypeId("custom_tiles"); // Set the map type to your custom tiles
    }
  }

  // Function to change the map tiles and type
  function changeMapToMoon() {
    if (mapRef) {
      const customTileLayer = new google.maps.ImageMapType({
        getTileUrl: (coord, zoom) => {
          const newZoom = zoom - 0;
          const bound = Math.pow(2, newZoom);
          // https://mw1.google.com/mw-planetary/mars/marsmaps_v1/{z}/{x}/{y}.jpg
          return `https://mw1.google.com/mw-planetary/lunar/lunarmaps_v1/clem_bw/{z}/{x}/{y}.jpg`
            .replace("{z}", newZoom.toString())
            .replace("{x}", coord.x.toString())
            .replace("{y}", (bound - coord.y - 1).toString());
        },
        tileSize: new google.maps.Size(256, 256), // Adjust based on your tile size
        name: "Custom Tile Layer",
        maxZoom: 18,
        minZoom: 0,
      });

      mapRef.mapTypes.set("custom_tiles", customTileLayer);
      mapRef.setMapTypeId("custom_tiles"); // Set the map type to your custom tiles
    }
  }

  // Function to change the map tiles and type
  function changeMapOverlay() {
    if (mapRef) {
      const customTileLayer = new google.maps.ImageMapType({
        getTileUrl: (coord, zoom) => {
          return `https://mw1.google.com/mw-planetary/lunar/lunarmaps_v1/clem_bw/{z}/{x}/{y}.jpg`
            .replace("{z}", zoom.toString())
            .replace("{x}", coord.x.toString())
            .replace("{y}", coord.y.toString());
        },
        tileSize: new google.maps.Size(256, 256), // Adjust based on your tile size
        name: "Custom Tile Layer",
        maxZoom: 18,
        minZoom: 0,
      });

      // Set the custom tile layer in the map's types
      mapRef.mapTypes.set("custom_tiles", customTileLayer);

      // Add the custom tile layer as an overlay
      mapRef.overlayMapTypes.push(customTileLayer);
    }
  }

  // Function to show stuff about the map
  function showMapData() {
    if (mapRef) {
      const handleMapChange = () => {
        const center = mapRef.getCenter();
        const zoom = mapRef.getZoom();
        if (center) {
          console.log({ lat: center.lat(), lng: center.lng() });
        }
        console.log(zoom);
      };

      // Initial set
      handleMapChange();

      // Add event listeners for map changes
      // 'idle', 'center_changed'
      google.maps.event.addListener(mapRef, "center_changed", handleMapChange);

      // Cleanup the event listener on component unmount
      // return () => {
      //   google.maps.event.removeListener(mapRef, 'idle', handleMapChange);
      // };
    }
  }

  // Function to add tiles to the map
  function addTilesToMap(map: google.maps.Map, folderPath: string) {
    const imageBounds = {
      north: 10.585815,
      south: 80.58378,
      east: 0.713124,
      west: -91.716357,
    };

    class UserTileOverlay extends google.maps.OverlayView {
      private map: google.maps.Map;
      private tileSize: google.maps.Size;
      private tiles: HTMLElement[] = [];
      private initialized: boolean = false;
      private folderPath: string;

      constructor(map: google.maps.Map, folderPath: string) {
        super();
        this.map = map;
        this.tileSize = new google.maps.Size(256, 256);
        this.folderPath = folderPath;
      }

      getTile(p: google.maps.Point, z: number, ownerDocument: Document): HTMLElement {
        console.log("getting tile");
        const tile = ownerDocument.createElement("div");
        tile.style.width = this.tileSize.width + "px";
        tile.style.height = this.tileSize.height + "px";
        tile.style.backgroundImage = `url(${this.getTileUrl(p, z)})`;
        tile.style.backgroundRepeat = "no-repeat";
        this.tiles.push(tile);
        console.log(tile);
        return tile;
      }

      getTileUrl(p: google.maps.Point, z: number): string {
        console.log(p);
        return `${this.folderPath}/${z}/${p.x}/${p.y}.png`;
      }

      initialize() {
        console.log("initializing");
        if (this.initialized) {
          console.log("already initialized");
          return;
        }
        this.map.overlayMapTypes.insertAt(1, null);
        this.initialized = true;
        console.log("finished initializing");
      }

      show() {
        this.initialize();
      }

      hide() {
        this.tiles.forEach((tile) => {
          tile.style.display = "none";
        });
      }
    }

    const userTileOverlay = new UserTileOverlay(map, folderPath);
    userTileOverlay.show();
  }

  // Function to get tile URI from a coord lat lng and zoom
  function getTileUrlCoord(coord: any, zoom: any) {
    var tileRange = 1 << zoom;
    var y = tileRange - coord.y - 1;
    var x = coord.x;
    if (x < 0 || x >= tileRange) {
      x = ((x % tileRange) + tileRange) % tileRange;
    }
    return new google.maps.Point(x, y);
  }

  function fromMercatorPixelToLatLng(pixel: any, zoom: any) {
    var CST = 6378137 * Math.PI;
    var res = (2 * CST) / 256 / Math.pow(2, zoom);
    var X = -CST + pixel.x * res;
    var Y = CST - pixel.y * res;
    var lon = (X / CST) * 180;
    var lat = (Math.atan(Math.sinh((Y / CST) * Math.PI)) / Math.PI) * 180;
    return new google.maps.LatLng(lat, lon);
  }

  // Function to get uri from a tile and a zoom
  function getTileUrl2(tile: any, zoom: any) {
    var mapbounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(42.57839622740581, -90.72119966363512),
      new google.maps.LatLng(42.58612239101804, -90.70985233883236),
    );
    var mapMinZoom = 14;
    var mapMaxZoom = 21;

    var ymax = 1 << zoom;
    var y = ymax - tile.y - 1;
    var tileBounds = new google.maps.LatLngBounds(
      fromMercatorPixelToLatLng(new google.maps.Point(tile.x * 256, (y + 1) * 256), zoom),
      fromMercatorPixelToLatLng(new google.maps.Point((tile.x + 1) * 256, y * 256), zoom),
    );
    if (mapbounds.intersects(tileBounds)) {
      return zoom + "/" + tile.x + "/" + tile.y + ".png";
    } else {
      return "https://gdal.org/resources/gdal2tiles/none.png";
    }
  }

  // Function to return a transparent png
  function createTransparentPng(width: number, height: number): String {
    // Create a canvas element
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    // Get the 2D context of the canvas
    const context = canvas.getContext("2d");

    if (!context) {
      throw new Error("Unable to get canvas context");
    }

    // Fill the canvas with a transparent rectangle
    context.fillStyle = "rgba(255, 255, 255, 0)"; // Fully transparent
    context.fillRect(0, 0, width, height);

    // Convert the canvas to a data URL
    const dataUrl = canvas.toDataURL("image/jpg");

    // Create a new image element
    const img = new Image();
    img.src = dataUrl;

    // Return the image element
    return dataUrl;
  }

  function addTilesToMap2(files: any) {
    console.log(files);
    if (mapRef) {
      const customTileLayer = new google.maps.ImageMapType({
        getTileUrl: (coord, zoom) => {
          let newCoord = getTileUrlCoord(coord, zoom);

          console.log("zoom: ", zoom.toString());
          console.log("coord x: ", coord.x.toString());
          console.log("coord y: ", coord.y.toString());
          console.log("newCoord y: ", newCoord.y.toString());
          // console.log("tile zoom, x: ", files?.["Tiles"]?.[zoom.toString()]?.[newCoord.x.toString()]);
          console.log(
            "tile",
            files?.["Tiles"]?.[zoom.toString()]?.[coord.x.toString()]?.[
              newCoord.y.toString() + ".png"
            ],
          );

          // ?.webkitRelativePath

          // return files?.[newCoord.toString()]?.[coord.x.toString()]?.[coord.y.toString()] || null;

          const transparentPng = createTransparentPng(256, 256);
          console.log(transparentPng);

          // // Convert the canvas to a data URL
          // const canvas = document.createElement('canvas');
          // const dataUrl = canvas.toDataURL('image/png');
          // const fileURL = URL.createObjectURL(files?.["Tiles"]?.[zoom.toString()]?.[coord.x.toString()]?.[newCoord.y.toString() + ".png"] || null);

          // return fileURL || transparentPng as string;

          const tileFile =
            files?.["Tiles"]?.[zoom.toString()]?.[coord.x.toString()]?.[
              newCoord.y.toString() + ".png"
            ];

          let fileURL2: string;

          if (tileFile instanceof File) {
            fileURL2 = URL.createObjectURL(tileFile);
          } else {
            // Handle the case where the file does not exist; you can return a default image or handle it as needed
            console.warn("Tile file not found. Using fallback image.");
            fileURL2 = createTransparentPng(256, 256) as string; // or a fallback URL
          }

          // Now you can use fileURL safely
          return fileURL2;

          // return `folderPath/{z}/{x}/{y}.jpg`
          //     .replace('{z}', zoom.toString())
          //     .replace('{x}', coord.x.toString())
          //     .replace('{y}', coord.y.toString());
        },
        tileSize: new google.maps.Size(256, 256), // Adjust based on your tile size
        name: "Custom Tile Layer",
        maxZoom: 25,
        minZoom: 0,
      });

      // // Set the custom tile layer in the map's types
      // mapRef.mapTypes.set('custom_tiles', customTileLayer);

      // // Add the custom tile layer as an overlay
      // mapRef.overlayMapTypes.push(customTileLayer);

      mapRef.mapTypes.set("custom_tiles", customTileLayer);
      // mapRef.setMapTypeId('custom_tiles'); // Set the map type to your custom tiles
      mapRef.overlayMapTypes.push(customTileLayer);
    }
  }

  // Function to handle the folder selection
  function handleFolderSelection(event: any) {
    const files = event?.target?.files as any;
    if (files) {
      // Assuming the first file is from the selected folder, we can derive the path
      const folderPath = files[0].webkitRelativePath.split("/").slice(0, -1).join("/");
      console.log("Selected folder path:", folderPath);
      const names = Array.from(files).map((file) => (file as any).name); // Get file names
      setFileNames(names); // Update state with file names

      if (mapRef) {
        // addTilesToMap(mapRef, folderPath);
        // addTilesToMap2(folderPath, files);
      } else {
        console.log("No map ref found!");
      }
    } else {
      console.log("Files were not found");
    }
  }

  // Function to handle the folder selection
  function handleFolderSelection2(event: any) {
    function objectToString(obj: any, depth = 0) {
      let result = "";
      const indent = "\t".repeat(depth); // Create an indentation string based on the current depth

      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
            // If the value is an object, recursively call objectToString
            result += `${indent}${key}:\n${objectToString(obj[key], depth + 1)}`;
          } else {
            // If it's a file object or primitive, just concatenate the key and value
            result += `${indent}${key}: ${obj[key]}\n`;
          }
        }
      }

      return result;
    }

    const files = event?.target?.files as any;
    if (files) {
      const folderStructure: any = {}; // Object to hold the folder structure

      Array.from(files).forEach((file: any) => {
        const relativePath = file.webkitRelativePath; // Get the relative path
        const pathParts = relativePath.split("/"); // Split by '/'

        // Create nested structure in folderStructure
        let currentLevel = folderStructure;
        pathParts.forEach((part: string, index: number) => {
          // If it's the last part, it's a file
          if (index === pathParts.length - 1) {
            currentLevel[part] = file; // Assign the file object itself
          } else {
            // Create a new folder if it doesn't exist
            if (!currentLevel[part]) {
              currentLevel[part] = {};
            }
            currentLevel = currentLevel[part]; // Move to the next level
          }
        });
      });

      console.log("Selected folder structure:", folderStructure);
      let thisString = objectToString(folderStructure);
      setDivString(thisString);
      // setFileStructure(folderStructure); // Update state with the structured file object

      if (mapRef) {
        // Call your function with folder structure
        addTilesToMap2(folderStructure);
      } else {
        console.log("No map ref found!");
      }
    } else {
      console.log("Files were not found");
    }
  }

  // Function to trigger the file input dialog
  function selectFolder() {
    const input = document.createElement("input");
    input.type = "file";
    input.webkitdirectory = true; // Allow folder selection
    input.onchange = handleFolderSelection2;
    input.click();
  }

  function addLayerToMapAM() {
    // 42.585815, -90.716357
    // 42.583780, -90.713124
    const imageBounds = {
      north: 42.585815,
      south: 42.58378,
      east: -90.713124,
      west: -90.716357,
    };

    // Options Documentation https://developers.google.com/maps/documentation/android-sdk/reference/com/google/android/libraries/maps/model/GroundOverlayOptions#GroundOverlayOptions()
    let historicalOverlay = new google.maps.GroundOverlay(
      "https://storage.googleapis.com/geo-devrel-public-buckets/newark_nj_1922-661x516.jpeg",
      imageBounds,
      {
        clickable: false,
      },
    );
    historicalOverlay.setMap(mapRef);
  }

  const { execute: executePublishData, isLoading: isPublishingData } = useApiCall({ successMessage: "Data published", errorAsToast: true });
  const { execute: executeGetOrg, isLoading: isGettingOrg } = useApiCall({ successMessage: "ORG data fetched", errorAsToast: true });
  const { execute: executeClearDB, isLoading: isClearingDB } = useApiCall({ successMessage: "Database cleared", errorAsToast: true });
  const { execute: executeNewZone, isLoading: isPublishingZone } = useApiCall({ successMessage: "Zone published", errorAsToast: true });
  const { execute: executeTestMission, isLoading: isPublishingMission } = useApiCall({ successMessage: "TaskList published", errorAsToast: true });
  const { execute: executeTestMission2, isLoading: isPublishingMission2 } = useApiCall({ successMessage: "TaskList Array published", errorAsToast: true });
  const { execute: executeTestMission3, isLoading: isPublishingMission3 } = useApiCall({ successMessage: "TaskList Path published", errorAsToast: true });
  const { execute: executeRunAI, isLoading: isRunningAI } = useApiCall({ successMessage: "Backend AI executed", errorAsToast: true });
  const { execute: executeClearHeartbeats, isLoading: isClearingHeartbeats } = useApiCall({ successMessage: "Heartbeat logs cleared", errorAsToast: true });

  function publishData() {
    return fetch(`/API/MongoDB/PostAVehicle`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  function runBackendAI() {
    return fetch(`/API/AI/Chat`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  function publishNewZone() {
    const currentTopicString: string = "orchestratorORG/JobSite/Session/";
    const propertyZoneType: any = 0;
    const pointsArray: any[] = [
      { lng: -90.7174416008633, lat: 42.58622789520555 },
      { lng: -90.71753816038783, lat: 42.585099596787636 },
      { lng: -90.71664766699489, lat: 42.585066082660944 },
      { lng: -90.71658329397853, lat: 42.58578663241422 },
      { lng: -90.7164706411999, lat: 42.58603239941755 },
      { lng: -90.71643845469173, lat: 42.58623906637493 },
    ];
    const propertyName: string = "Engineering Tool Zone";
    const propertyDescription: string = "This is a description of the Zone";
    return fetch(`/API/Save/BoundaryNew`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        zoneType: propertyZoneType,
        pointsArray: pointsArray,
        currentTopicString: currentTopicString + "Shape/" + propertyName.toString(),
        deleted: false,
        description: propertyDescription,
      }),
    });
  }

  // interface TransparentPngProps {
  //     width: number;
  //     height: number;
  // }

  // const TransparentPng: React.FC<TransparentPngProps> = ({ width, height }) => {
  //     const imgRef = useRef<HTMLImageElement>(null);

  //     useEffect(() => {
  //         // Create a canvas element
  //         const canvas = document.createElement('canvas');
  //         canvas.width = width;
  //         canvas.height = height;

  //         // Get the 2D context of the canvas
  //         const context = canvas.getContext('2d');

  //         if (!context) {
  //             throw new Error("Unable to get canvas context");
  //         }

  //         // Fill the canvas with a transparent rectangle
  //         context.fillStyle = 'rgba(216, 13, 13, 0.66)'; // Fully transparent
  //         context.fillRect(0, 0, width, height);

  //         // Convert the canvas to a data URL
  //         const dataUrl = canvas.toDataURL('image/png');

  //         // Set the src of the img element
  //         if (imgRef.current) {
  //             imgRef.current.src = dataUrl;
  //         }
  //     }, [width, height]);

  //     return <img ref={imgRef} alt="Transparent PNG" />;
  // };

  function publishAddTestMission() {
    const currentTopicString: string =
      "orchestratorORG/JobSite/Session/SiteManager/1/1/TaskList/ADT310Biggie";
    const propertyZoneType: any = 0;
    const pointsArray: any[] = [
      { lng: -90.7174416008633, lat: 42.58622789520555 },
      { lng: -90.71753816038783, lat: 42.585099596787636 },
      { lng: -90.71664766699489, lat: 42.585066082660944 },
      { lng: -90.71658329397853, lat: 42.58578663241422 },
      { lng: -90.7164706411999, lat: 42.58603239941755 },
      { lng: -90.71643845469173, lat: 42.58623906637493 },
    ];
    const propertyDescription: string = "This is a description of the Zone";
    return fetch(`/API/Save/AddTestMission`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        lng: -90.71753807296656,
        lat: 42.582416676021566,
        zoneType: propertyZoneType,
        pointsArray: pointsArray,
        currentTopicString: currentTopicString,
        deleted: false,
        description: propertyDescription,
      }),
    });
  }

  function publishAddTestMission2() {
    const currentTopicString: string =
      "orchestratorORG/JobSite/Session/SiteManager/1/1/TaskList/ADT310Biggie";
    const propertyDescription: string = "This is a description of the Zone";
    return fetch(`/API/Save/AddTestMission2`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        lat: 42.583123859172325,
        lng: -90.71535221122974,
        lng2: -90.71753807296656,
        lat2: 42.582416676021566,
        lng3: -90.71708544503237,
        lat3: 42.58444066159481,
        currentTopicString: currentTopicString,
        deleted: false,
        description: propertyDescription,
      }),
    });
  }

  function publishAddTestMission3() {
    const currentTopicString: string =
      "orchestratorORG/JobSite/Session/SiteManager/Orchestrator/U292N4F/TaskList/ADT310Biggie";
    const propertyDescription: string = "This is a description of the Zone";
    return fetch(`/API/Save/AddTestMission3`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        lat: 42.583123859172325,
        lng: -90.71535221122974,
        lng2: -90.71753807296656,
        lat2: 42.582416676021566,
        lng3: -90.71708544503237,
        lat3: 42.58444066159481,
        currentTopicString: currentTopicString,
        deleted: false,
        description: propertyDescription,
      }),
    });
  }

  function publishClearDataBase() {
    return fetch(`/API/Data/RemoveAllData`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  function clearAllHeartbeatLogs() {
    return fetch(`/API/HeartbeatLogs/clearAll`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });
  }

  async function sendMQTTMessage() {
    setIsSendingMQTT(true);
    setMqttFeedback(null);
    try {
      const response = await fetch(`/API/Save/MQTTMessageManual`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          topic: topic,
          message: message,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      setMqttFeedback({ type: "success", msg: "Message sent" });
    } catch (error) {
      setMqttFeedback({ type: "error", msg: "Failed to send MQTT message" });
    } finally {
      setIsSendingMQTT(false);
    }
  }

  function getOrgSpecificData() {
    return fetch(`/API/MQTT/ORG`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        organizationId: "testORG",
      }),
    });
  }

  function navigateToAdminDashboard() {
    window.open("/secret-admin-dashboard-8823", "_blank");
  }

  async function handleClose() {
    breakMQTTLoop = true;
    onClose();
  }

  // console.log("fullMQTT", fullMQTT);

  return (
    <div style={{ padding: "20px", maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}>
      <MQTTOrgExplorer
        fullMQTT={fullMQTT}
        orgName={orgName}
        setOrgName={setOrgName}
        devToolsOrgOverride={devToolsOrgOverride}
        onRevertToHeaderOrg={onRevertToHeaderOrg}
        headerOrgName={headerOrgName}
      />

      <h2>Cab Control Settings</h2>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <FormControlLabel
          control={
            <Switch
              checked={cabControlFullscreen}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setCabControlFullscreen(e.target.checked)
              }
            />
          }
          label={cabControlFullscreen ? "Fullscreen on Cab Control (On)" : "Fullscreen on Cab Control (Off)"}
        />
      </div>

      <h1>MQTT Explorer</h1>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
        <FormControlLabel
          control={
            <Switch
              checked={fetchEnabled}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFetchEnabled(e.target.checked)
              }
            />
          }
          label={fetchEnabled ? "Fetching Live Data (Active)" : "Fetch Live Data (Paused)"}
        />
      </div>
      <div style={{ paddingLeft: "10px", borderLeft: "2px solid #eee" }}>
        <JsonTreeViewer data={mqttData} initialExpanded={false} />
      </div>

      <h4>MQTT Send Message</h4>
      <input
        type="text"
        placeholder="MQTT Topic"
        value={topic}
        disabled={isSendingMQTT}
        onChange={(e) => { setTopic(e.target.value); setMqttFeedback(null); }}
      />
      <input
        type="text"
        placeholder="MQTT Message"
        value={message}
        disabled={isSendingMQTT}
        onChange={(e) => { setMessage(e.target.value); setMqttFeedback(null); }}
      />
      <button onClick={sendMQTTMessage} disabled={!topic || !message || isSendingMQTT}>
        {isSendingMQTT ? "Sending..." : "Send"}
      </button>
      {mqttFeedback && (
        <span style={{ marginLeft: "8px", fontSize: "13px", color: mqttFeedback.type === "success" ? "#22863a" : "#d73a49" }}>
          {mqttFeedback.msg}
        </span>
      )}

      <br />
      <br />

      {/* <TransparentPng width={100} height={100} /> */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 12px", maxWidth: "420px" }}>
        <Button
          onClick={() => executeClearDB(publishClearDataBase)}
          disabled={isClearingDB}
          loading={isClearingDB}
        >
          Clear Database
        </Button>
        <Button
          onClick={() => executeGetOrg(getOrgSpecificData)}
          disabled={isGettingOrg}
          loading={isGettingOrg}
        >
          Get ORG specific data
        </Button>
        <Button
          onClick={() => executeTestMission3(publishAddTestMission3)}
          disabled={isPublishingMission3}
          loading={isPublishingMission3}
        >
          Publish New TaskList Path with Array
        </Button>
        <Button
          onClick={() => executeTestMission2(publishAddTestMission2)}
          disabled={isPublishingMission2}
          loading={isPublishingMission2}
        >
          Publish New TaskList Array
        </Button>
        <Button
          onClick={() => executeTestMission(publishAddTestMission)}
          disabled={isPublishingMission}
          loading={isPublishingMission}
        >
          Publish New TaskList
        </Button>
        <Button
          onClick={() => executeNewZone(publishNewZone)}
          disabled={isPublishingZone}
          loading={isPublishingZone}
        >
          Publish New Zone
        </Button>
        <Button onClick={handleLogOut}>Log Out</Button>
        <Button onClick={navigateToAdminDashboard}>Secret Admin Dashboard</Button>
        <Button
          onClick={() => executePublishData(publishData)}
          disabled={isPublishingData}
          loading={isPublishingData}
        >
          Publish Data
        </Button>
        <Button
          onClick={() => executeRunAI(runBackendAI)}
          disabled={isRunningAI}
          loading={isRunningAI}
        >
          Run Backend AI
        </Button>
        <Button onClick={addLayerToMapAM}>Add Image to Map</Button>
        <Button onClick={showMapData}>Console Log Map Data</Button>
        <Button onClick={changeMapOverlay}>Add Moon map overlay</Button>
        <Button onClick={changeMapToMoon}>Change Map To Moon</Button>
        <Button onClick={selectFolder}>Add Layer to Map</Button>
        <Button
          onClick={() => executeClearHeartbeats(clearAllHeartbeatLogs)}
          disabled={isClearingHeartbeats}
          loading={isClearingHeartbeats}
        >
          Clear Heartbeat Logs
        </Button>
      </div>
      <br />
      <div>{divString}</div>
      <textarea
        rows={10}
        cols={50}
        value={fileNames.join("\n")} // Join file names with new lines
        readOnly
        placeholder="Uploaded file names will appear here..."
      />
      <TestMongoDB></TestMongoDB>
      <div style={{ marginTop: "20px", marginBottom: "20px", borderTop: "2px solid #ccc" }}></div>
      <EndToEndTest fullMQTT={fullMQTT} setOrgName={setOrgName} />
      <div style={{ marginTop: "20px", marginBottom: "20px", borderTop: "2px solid #ccc" }}></div>
      <PipelineTimingTest orgName={orgName} fullMQTT={fullMQTT} />
      <p>All MQTT Data and history</p>

      <ChatComponent />
      {/* <FullMqttDisplay fullMQTT={fullMQTT} /> */}
    </div>
  );
};

export default EngineeringTools;
